/* eslint-disable react/jsx-no-useless-fragment */
import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import {
    Typography,
    Button,
    DialogContent,
} from '@mui/material'

import { useTranslation } from 'shared/hooks/useSafeTranslation'
import useStyle from 'shared/hooks/useStyle'
import getGlobalAssetUrl from 'shared/utils/getGlobalAssetUrl'
import ROUTE_KEYS from 'shared/utils/routeKeys'
import styles from './NoAsset.style'

const propTypes = { onRetry: PropTypes.func.isRequired }

const NoAsset = ({ onRetry }) => {
    const classes = useStyle(styles)
    const { t } = useTranslation()
    const navigate = useNavigate()

    const onCancel = useCallback(() => {
        navigate(ROUTE_KEYS.MAIN)
    }, [navigate])

    return (
        <>
            <DialogContent css={classes.dialogContentRoot}>
                <div>
                    <img
                        css={classes.icon}
                        alt="logo"
                        src={getGlobalAssetUrl('skycenter/error_sorry.svg')}
                    />
                </div>
                <div css={classes.content}>
                    <div css={classes.text}>
                        <Typography
                            variant="h3"
                            css={classes.message}
                        >
                            {t('NO_SKYCELL_ASSET')}
                        </Typography>
                    </div>
                    <div
                        css={classes.actions}
                    >
                        <Button
                            data-testid="cancel-button"
                            css={classes.button}
                            onClick={onCancel}
                        >
                            {t('CANCEL')}
                        </Button>
                        <Button
                            data-testid="retry-button"
                            css={classes.button}
                            onClick={onRetry}
                        >
                            {t('RETRY')}
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </>
    )
}

NoAsset.propTypes = propTypes

export default NoAsset
